const mEditionAcademyLegalsEmailClause = {
  mEditionAcademyLegalsEmailClause: {
    alerts: {
      updateAcademiaLegales: {
        error: 'Un error ha ocurrido. Verifica los datos ingresados y vuelve a intentarlo.',
        success: 'Los datos legales para Cláusula Correo fueron guardados exitosamente.'
      }
    },

    buttonPrimary: 'GUARDAR',

    inputs: {
      text: {
        label: 'Cláusula Correo'
      }
    }
  }
}

export default mEditionAcademyLegalsEmailClause
